var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormFilling(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 36,
    viewBox: "0 0 41 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 -4C34.5304 -4 35.0391 -3.78929 35.4142 -3.41421C35.7893 -3.03914 36 -2.53043 36 -2V5.514L18.002 23.514L17.99 31.99L26.482 32.002L36 22.484V34C36 34.5304 35.7893 35.0391 35.4142 35.4142C35.0391 35.7893 34.5304 36 34 36H2C1.46957 36 0.960859 35.7893 0.585786 35.4142C0.210714 35.0391 0 34.5304 0 34V-2C0 -2.53043 0.210714 -3.03914 0.585786 -3.41421C0.960859 -3.78929 1.46957 -4 2 -4H34ZM37.556 9.616L40.384 12.444L24.828 28L21.996 27.996L22 25.172L37.556 9.616ZM18 16H8V20H18V16ZM24 8H8V12H24V8Z",
    fill: "#0076E9",
    fillOpacity: 0.58
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormFilling);
export default __webpack_public_path__ + "static/media/form-filling.cb8c19c41e6e9ac0b3cc72c64a3662bf.svg";
export { ForwardRef as ReactComponent };